import * as React from "react";

export type OpeningTitleQueryStore = Readonly<{
  read: (problemSetId: number) => string;
  write: (problemSetId: number, query: string) => void;
}>;

export function useOpeningTitleQueryStore(): OpeningTitleQueryStore {
  const queriesRef = React.useRef(new Map<number, string>());

  return React.useMemo(
    () => ({
      read: (problemSetId) => queriesRef.current.get(problemSetId) ?? "",
      write: (problemSetId, query) => {
        queriesRef.current.set(problemSetId, query);
      },
    }),
    [],
  );
}
